import api from './api';

export const getLoopsData = (page, params) => {
  return api.get('admin/LoopLink', { params: { page: page, limit: 10, order: 'createdAt', direction: 'DESC', ...params } });
};

export const updateLoop = (loopId, update) => {
  return api.put(`admin/LoopLink/item/${loopId}`, { object: update });
};